// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__nWHyr","unreadBadge":"styles_unreadBadge__W_ElX","modalContent":"styles_modalContent___aYbc","modal":"styles_modal__1Xpv0"};